import { CurrencyAPI } from '../../../api/datamanager/CurrencyAPI';

export class CurrenciesCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = CurrencyAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(provider, model, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === model.id) {
            apiResult = CurrencyAPI.create(model, provider);
            successMessage = "Moeda criada com sucesso";
        }
        else {
            apiResult = CurrencyAPI.update(model.id, model);
            successMessage = "Moeda editada com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(provider, modelId, successCallback, errorCallback) {
        const apiResult = CurrencyAPI.delete(modelId, provider);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Moeda eliminada com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
